var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { api } from "../../../../api/API";
import { LiteKitPopup } from "../../settings/LiteKitPopup";
import { useContext } from "react";
import { EditContext } from "../../../../misc/scroller/EditProvider";
import { DropDownContext } from "../../settings/DropDowns";
import { jsx as _jsx } from "react/jsx-runtime";
export function LiteKitCreate(props) { const edit = useContext(EditContext); const ddlCtx = useContext(DropDownContext); return /*#__PURE__*/ _jsx(LiteKitPopup, { entityName: props.createName, name: props.createName, showCreateGlobalOpt: true, onDone: (v) => __awaiter(this, void 0, void 0, function* () { if (v.createGlobal) {
        yield api.ddlOptions.upsertDefaultLiteKitProfile({ name: props.createName, file: v.file });
        ddlCtx.reload();
        yield edit.update(Object.assign({}, props.value, { updatedAt: new Date().toISOString(), doorElevationProfileDefaultName: props.createName }));
    }
    else {
        yield edit.update(Object.assign({}, props.value, { updatedAt: new Date().toISOString(), doorElevationProfileCustomFile: v.file }));
    } edit.reload(); props.onClose(); }), onCancel: props.onClose }); }
